<template>
  <div class="map-printing-map-buttons" v-if="!interacting">
    <button
      class="map-printing-map-button nice-blue-background"
      @click="selectPlots"
    >ZAZNACZ DZIAŁKI</button>
    <button
      class="map-printing-map-button nice-blue-background"
      @click="selectPlotsDraw"
    >WYRYSUJ OBSZAR</button>
  </div>
  <div class="map-printing-map-buttons" v-else-if="interacting=='drawing'">
    <button class="map-printing-map-button nice-blue-background" @click="selectOff">WYŁĄCZ</button>
    <button class="map-printing-map-button nice-blue-background" @click="selectOff">OK</button>
  </div>
  <div class="map-printing-map-buttons" v-else>
    <button class="map-printing-map-button nice-blue-background" @click="selectOff">WYŁĄCZ</button>
  </div>
</template>

<style lang="scss">
.map-printing-map {
  $gap: 10px;

  position: relative;

  .map-printing-map-buttons {
    position: absolute;
    left: 0px;
    top: 0px;
    padding: $gap/2;

    .map-printing-map-button {
      margin: $gap/2;

      border: none;

      width: 200px;
      height: 40px;
      color: white;
      cursor: pointer;
    }
  }
}
</style>

<script>
import Select from "ol/interaction/Select.js";
import { singleClick } from "ol/events/condition.js";
import { Draw, Modify } from "ol/interaction";
import { Vector as VectorLayer } from "ol/layer.js";
import { Vector as VectorSource } from "ol/source.js";
import DoubleClickZoom from "ol/interaction/DoubleClickZoom";
import GeoJSON from "ol/format/GeoJSON";

import turf from "turf";

export default {
  props: ["printingMap"],
  data() {
    return {
      interacting: false
    };
  },
  computed: {
    map() {
      return this.printingMap;
    },
    ficzeryLayer() {
      return this.getLayerByName("ficzery");
    },
    explodedOfertyLayer() {
      return this.getLayerByName("explodedOferty");
    },
    offerFilter() {
      console.log(this.interacting, "filter");
      switch (this.interacting) {
        case false:
          return oferta => true;
        case "selecting":
          return oferta =>
            this.activeInteraction
              .getFeatures()
              .getArray()
              .some(feature => feature.get("id") == oferta.id);
        case "editing":
          let drawn_polygon = new GeoJSON({
            featureProjection: "EPSG:3857"
          }).writeFeatureObject(this.drawSource.getFeatures()[0]).geometry;
          return oferta => {
            let polygons = oferta.geometry.coordinates.map(c => ({
              coordinates: c,
              type: "Polygon"
            }));
            return polygons.some(polygon => {
              try {
                return turf.intersect(drawn_polygon, turf.buffer(polygon, 0));
              } catch (e) {
                console.error("-----");
                console.error(e);
                console.error("Buggy offer id: ", oferta.id);
                console.error("Buggy offer: ", oferta);
                console.error("Buggy polygon: ", polygon);
                console.error("Buggy polygon json: ", JSON.stringify(polygon));
                console.error("-----");
                return true;
              }
            });
          };
        default:
          return oferta => true;
      }
    }
  },
  methods: {
    getLayerByName(name) {
      return this.map
        .getLayers()
        .getArray()
        .find(l => {
          return l.get("name") == name;
        });
    },
    selectOff() {
      this.map.removeInteraction(this.activeInteraction);
      this.explodedOfertyLayer.setVisible(false);
      this.activeInteraction = undefined;
      this.interacting = false;

      if (this.drawLayer) {
        this.map.removeLayer(this.drawLayer);
        this.drawLayer = undefined;
      }
    },
    selectPlots() {
      this.explodedOfertyLayer.setVisible(true);
      this.activeInteraction = new Select({
        layers: [this.explodedOfertyLayer],
        addCondition: singleClick,
        toggleCondition: singleClick
      });
      this.map.addInteraction(this.activeInteraction);
      this.interacting = "selecting";
    },
    selectPlotsDraw() {
      this.drawSource = new VectorSource({});
      this.drawLayer = new VectorLayer({
        source: this.drawSource
      });
      this.map.addLayer(this.drawLayer);
      this.activeInteraction = new Draw({
        source: this.drawSource,
        type: "Polygon"
      });
      this.setDblClick(false);
      this.activeInteraction.on("drawend", () => {
        setTimeout(() => {
          this.map.removeInteraction(this.activeInteraction);
          this.activeInteraction = undefined;
          this.setDblClick(true);
          this.activeInteraction = new Modify({
            source: this.drawSource,
            type: "Polygon"
          });
          this.map.addInteraction(this.activeInteraction);
          this.interacting = "editing";
        }, 0);
      });
      this.map.addInteraction(this.activeInteraction);
      this.interacting = "drawing";
    },
    setDblClick(state) {
      /* https://github.com/openlayers/openlayers/issues/3610 dblclick after drawend */
      setTimeout(() => {
        for (let interaction of this.map.getInteractions().getArray()) {
          if (interaction instanceof DoubleClickZoom) {
            interaction.setActive(state);
          }
        }
      }, 0);
    }
  }
};
</script>
